import React, { useContext } from 'react';
import { CopyUrlButton, SocialBar } from 'wix-ui-tpa/cssVars';
import { Facebook, XCorp, LinkedIn } from '@wix/wix-ui-icons-common/on-stage';
import settingsParams from '../../settingsParams';
import { useBi, useEnvironment, useTranslation } from '@wix/yoshi-flow-editor';
import { AppContext } from '../SettingsProvider/SettingsProvider';
import { ISettingsContextValue } from '@wix/tpa-settings';
import { useSettings } from '@wix/tpa-settings/react';
import { st, classes } from './SocialBar.st.css';
import { faqButtonClickSrc63Evid836 } from '@wix/bi-logger-labs-data/v2';

enum SocialMedia {
  'Facebook' = 'facebook',
  'Twitter' = 'twitter',
  'LinkedIn' = 'linkedin',
  'Copy' = 'copy',
}
const SocialWrapper = (props: { questionId: string }) => {
  const logger = useBi();
  const settings: ISettingsContextValue = useSettings();
  const { baseURL } = useContext(AppContext);
  const env = useEnvironment();
  const { t } = useTranslation();
  const { appDefinitionId } = env;
  const { questionId } = props;
  const { facebook, twitter, linkedin, copyQuestionLink, show } = settings.get(
    settingsParams.social,
  );
  const showSocial = facebook || twitter || linkedin || copyQuestionLink;
  if (!show || !showSocial) {
    return null;
  }
  const isEditor = env.isEditor || env.isPreview;
  const socialShare = (media: SocialMedia) => {
    const shareUrl = new URL(baseURL);
    shareUrl.searchParams.set('questionId', questionId);
    shareUrl.searchParams.set('appDefId', appDefinitionId);
    const navigationURL = shareUrl.toString();
    let url = '';
    switch (media) {
      case SocialMedia.Facebook:
        url = 'https://www.facebook.com/sharer/sharer.php?u=';
        break;
      case SocialMedia.Twitter:
        url = 'https://twitter.com/intent/tweet?url=';
        break;
      case SocialMedia.LinkedIn:
        url = 'https://www.linkedin.com/shareArticle?mini=true&url=';
        break;
      case SocialMedia.Copy:
        return navigationURL;
      default:
        url = '';
    }
    if (url !== '') {
      url += encodeURIComponent(navigationURL);
      window.open(url, '_blank', 'top=200, left=200, width=700, height=500');
    }
    logger.report(
      faqButtonClickSrc63Evid836({
        button_name: media,
        action: 'link',
      }),
    );
    return url;
  };

  return (
    <div className={st(classes.socialBarWrapper)}>
      <SocialBar className={st(classes.socialBar)}>
        {facebook && (
          <SocialBar.Icon
            tooltip={
              isEditor
                ? t('social.icons.disablePreviewMode')
                : t('display.tab.social.facebook')
            }
            icon={<Facebook />}
            onClick={() => socialShare(SocialMedia.Facebook)}
          />
        )}

        {twitter && (
          <SocialBar.Icon
            tooltip={
              isEditor
                ? t('social.icons.disablePreviewMode')
                : t('display.tab.social.twitter')
            }
            icon={<XCorp />}
            onClick={() => socialShare(SocialMedia.Twitter)}
          />
        )}

        {linkedin && (
          <SocialBar.Icon
            tooltip={
              isEditor
                ? t('social.icons.disablePreviewMode')
                : t('display.tab.social.linkedin')
            }
            icon={<LinkedIn />}
            onClick={() => socialShare(SocialMedia.LinkedIn)}
          />
        )}

        {copyQuestionLink && (
          <CopyUrlButton
            tooltipText={
              isEditor
                ? t('social.icons.disablePreviewMode')
                : t('display.tab.social.copyQuestionLink')
            }
            successText={t('display.tab.social.copiedQuestionLink')}
            url={socialShare(SocialMedia.Copy)}
          />
        )}
      </SocialBar>
    </div>
  );
};
export default SocialWrapper;
